import {init} from '@sentry/react'

if (process.env.NODE_ENV === 'production') {
  const dsn = 'https://ec4ced35c3704319b0c6ab21f464cf87@sentry.kensho.com/195'
  const host = window.location.hostname

  init({dsn, environment: host})
}
